var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrownusers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91146 12.25V11.0833C9.91146 10.4645 9.66563 9.871 9.22804 9.43342C8.79046 8.99583 8.19696 8.75 7.57812 8.75H2.91146C2.29262 8.75 1.69913 8.99583 1.26154 9.43342C0.823958 9.871 0.578125 10.4645 0.578125 11.0833V12.25",
    stroke: "#F05F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25521 6.41667C6.54387 6.41667 7.58854 5.372 7.58854 4.08333C7.58854 2.79467 6.54387 1.75 5.25521 1.75C3.96654 1.75 2.92188 2.79467 2.92188 4.08333C2.92188 5.372 3.96654 6.41667 5.25521 6.41667Z",
    stroke: "#F05F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 12.2523V11.0856C13.4215 10.5686 13.2494 10.0664 12.9327 9.65781C12.6159 9.24921 12.1725 8.95737 11.6719 8.82812",
    stroke: "#F05F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32812 1.82812C9.83003 1.95663 10.2749 2.24853 10.5926 2.65781C10.9103 3.06708 11.0827 3.57044 11.0827 4.08854C11.0827 4.60664 10.9103 5.11001 10.5926 5.51928C10.2749 5.92855 9.83003 6.22045 9.32812 6.34896",
    stroke: "#F05F23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownusers);
export default __webpack_public_path__ + "static/media/brownusers.14f314ff7c3d39a9e0ee48bde8b14a2c.svg";
export { ForwardRef as ReactComponent };